import { render, staticRenderFns } from "./VoiceAgentPhoneNumberInboundAgentChanged.vue?vue&type=template&id=48440c4a"
import script from "./VoiceAgentPhoneNumberInboundAgentChanged.vue?vue&type=script&lang=js"
export * from "./VoiceAgentPhoneNumberInboundAgentChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports